import Vue from 'vue'

export default {
  setPermissions: (state, permissions) => {
    Vue.set(state, 'userPermissions', permissions)
  },

  setIgnore: (state) => {
    let x = (state.ignore + 1) % 3
    Vue.set(state, 'ignore', x)
  },
}